import React from 'react';

const MongoDB_Charts = () => {
  return (
    <div>
      <h1>MongoDB_Charts Component</h1>
      <p>This is the MongoDB_Charts page.</p>
    </div>
  );
};

export default MongoDB_Charts;
